var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("Unfortunately, you don't have access for this feature")])])])
}]

export { render, staticRenderFns }